import '../modules/consultationForm';
import testimonialsSlider from '../modules/testimonials';

document.addEventListener("DOMContentLoaded", () => {
    testimonialsSlider();
});